import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PrimaryButton, PrimaryButtonInline } from '../Button/Button';
import NamedLink from '../NamedLink/NamedLink';

import css from './AddToCartButton.module.css';
import classNames from 'classnames';

const AddToCartButton = ({
  isOwnListing,
  isInCart,
  asCartLink,
  onCartToggle,
  rootClassName,
  className,
  ...buttonProps
}) => {
  const classes = classNames(rootClassName || css.root, className);

  const handleCartToggle = () => {
    if (isOwnListing) {
      return;
    }

    onCartToggle?.(isInCart ? -1 : 1);
  };

  if (isInCart && asCartLink) {
    return (
      <NamedLink name="CartPage" className={classes} {...buttonProps}>
        <PrimaryButton>
          <FormattedMessage id="AddToCartButton.goToCart" />
        </PrimaryButton>
      </NamedLink>
    );
  }

  return (
    <PrimaryButtonInline {...buttonProps} className={classes} onClick={handleCartToggle}>
      <FormattedMessage
        id={isInCart ? 'AddToCartButton.removeFromCart' : 'AddToCartButton.addToCart'}
      />
    </PrimaryButtonInline>
  );
};

export default AddToCartButton;
